export default __webpack_public_path__ + "static/media/4.375e54ac.svg";